<template>
    <div>
        <v-divider></v-divider>
        <!-- <mbs-page-tab
            v-if="MY_LINKS"
            :items="MY_LINKS"/> -->
        <v-container grid-list-xl>
            <v-layout align-center="" justify-center="">
                <v-col sm="12" cols="12">
                    <br>

                    <!-- Period controls -->
                    <v-card>
                        <v-card-text>
                            <v-row dense align="center">
                                <v-col cols="12" md="4">
                                    <v-btn-toggle v-model="period_type" mandatory dense color="primary" group>
                                        <v-btn value="day">Daily</v-btn>
                                        <v-btn value="week">Weekly</v-btn>
                                        <v-btn value="month">Monthly</v-btn>
                                    </v-btn-toggle>
                                </v-col>

                                <v-col cols="12" md="4">
                                    <v-menu
                                        v-model="date_menu"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                :value="SelectedPeriodLabel"
                                                label="Period"
                                                prepend-inner-icon="mdi-calendar"
                                                readonly
                                                filled
                                                hide-details
                                                v-bind="attrs"
                                                v-on="on"
                                            />
                                        </template>
                                        <v-date-picker
                                            v-model="selected_date"
                                            :type="period_type === 'month' ? 'month' : 'date'"
                                            no-title
                                            @input="ON_DATE_PICKED"
                                        />
                                    </v-menu>
                                </v-col>

                                <v-col cols="12" md="4">
                                    <!--
                                        ASSUMPTION: tills are available the same way Outlets are in your
                                        existing pages (a flat list with key/name). If your till list lives
                                        somewhere else (e.g. derived from Cashups/DayShifts), swap the
                                        TillsData computed below to match — this dropdown just needs
                                        {key, name} pairs.
                                    -->
                                    <v-autocomplete
                                        v-model="selected_till_key"
                                        :items="TillsData"
                                        item-value="key"
                                        item-text="name"
                                        label="Till (leave blank for company-wide)"
                                        prepend-inner-icon="mdi-point-of-sale"
                                        clearable
                                        filled
                                        hide-details
                                    />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <br>

                    <!-- Summary stats -->
                    <v-row dense v-if="CurrentReport">
                        <v-col v-for="(stat,i) in SummaryStats" :key="i" cols="6" md="2">
                            <v-card outlined>
                                <v-card-text class="text-center pa-3">
                                    <div class="text-caption grey--text text--darken-1">{{stat.label}}</div>
                                    <div class="text-h6 font-weight-bold">{{stat.value}}</div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>

                    <br v-if="CurrentReport">

                    <!-- Items table -->
                    <v-card> 
                        <mbs-item-manager
                            :table_title="ReportTypes[period_type]?.names"
                            :table_title_icon="'mdi-script-text-outline'"
                            :add_vertical_lines="true"
                            v-model="input_table"
                            :top_label="false"
                            :name_items="NAME_ITEMS"
                            :name_item="NAME_ITEM"
                            :header_items="HEADER_ITEMS"
                            :data_items="ReportItemsList"
                            :loading="loading_report"
                            :total_item_values="TOTAL_ITEM_VALUES"
                            :table_actions="table_actions"
                            :table_tabs="tabs"
                            @SELECT_TABLE_ACTION="TABLE_ACTION"
                            @SELECT_ITEM_ACTION="ITEM_ACTION"
                        />
                    </v-card>
                    <br><br>
                </v-col>
            </v-layout>
        </v-container>
        <div> 
            <mbs-sales-audit-sync :dayshifts="DayShifts" />
        </div>
    </div>
</template>

<script>
    import DATA from "../../../../../plugins/DATA"
    let PAGE_NAME = "AGGREGATED_SALES_REPORT"
    import {mapState} from "vuex"
    export default {
        name:PAGE_NAME,
        data() {
            return {
                PAGE_LOAD:false, 
                NAME_ITEMS:"Aggregated Items",
                NAME_ITEM:"Aggregated Item", 
                period_type:'day',
                selected_date:null,
                dialog_audit_aggregate_sales:true,
                date_menu:false,
                selected_till_key:null, 
                report_data:null,   // raw report node returned for the selected period
                loading_report:false,

                table_actions:[
                    {type:"action",btn:true,icon:"mdi-refresh",action:"refresh",color:"secondary",outlined:false,text:"Refresh"},
                    {type:"action",btn:true,icon:"mdi-receipt-text-check",action:"audit_aggregate_sales",color:"secondary",outlined:false,text:"Audit Aggregate Sales"},
                    {type:"action",icon:"mdi-microsoft-excel",action:"export_excel",color:"secondary",outlined:false,text:"Export to Excel"},
                ],
                tabs:[
                    {name:"Items"},
                    {name:"Groups"},
                    {name:"Departments"}
                ], 
                input_table:null,
                DayShifts:null,
            }
        },
        created() {
            try {
                this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);  
                if (this.period_type === 'month') {
                    this.selected_date = this.moment().format('YYYY-MM')
                } else {
                    this.selected_date = this.moment().format('YYYY-MM-DD')
                }
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME,
                })
            }
        },
        mounted() {
            try {
                this.MBS.actions.header({
                    show:true,
                    type:'subToolbar',
                    images:null,
                    color:'black',
                    height:"300",
                    opacity:'0.1'
                })
                this.FETCH_REPORT()
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'mounted',
                    page:PAGE_NAME,
                })
            }
        },
        computed: {
            moment(){
                return this.MBS.date.moment
            },
            MY_LINKS(){
                let thisLinks = this.MBS.actions.FIND_SUB_LINKS("sales",3,true)
                return thisLinks
            },
            ...mapState({
                SelectedCompany: state=> state.items['SELECTED_COMPANY'],
            }),
            // ASSUMPTION: a flat Tills list exists under DATA.ITEMS.TILLS, mirroring how
            // Outlets/Departments are mapped in your other pages. Adjust the state key /
            // DATA.ITEMS reference if your till list is sourced differently.
            ...mapState({
                Tills: state=> state.items[(DATA.ITEMS.TILLS?.values || 'TILLS').toUpperCase()],
                JoinedTills: state=> state.join[(DATA.ITEMS.TILLS?.values || 'TILLS').toUpperCase()],
                Items: state=> state.items[(DATA.ITEMS.ITEMS.values).toUpperCase()],
                JoinedItems: state=> state.join[(DATA.ITEMS.ITEMS.values).toUpperCase()],
                AggregatedReports: state=> state.items[(DATA.ITEMS.AGGREGATED_REPORTS.values).toUpperCase()],
            }),
            TillsData(){
                let items = this.JoinedTills?this.JoinedTills:this.Tills
                if(!items){return []}
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("name",true))
                return list
            },
            ItemsData(){
                let items = this.JoinedItems?this.JoinedItems:this.Items 
                return items
            },

            SelectedPeriodLabel(){
                let date = this.selected_date
                if(!date){return null}
                if(this.period_type === 'month'){
                    return this.moment(date).format('MMMM YYYY')
                }
                if(this.period_type === 'week'){
                    return 'Week of '+this.moment(date).format('Do MMM YYYY')
                }
                return this.moment(date).format('Do MMM YYYY')
            },

            CurrentReport(){
                let timestamp = this.moment.utc(this.selected_date).valueOf()
                let period_keys = this.GET_PERIOD_KEYS(timestamp)
                let period_type = this.period_type
                let till_key = this.selected_till_key
                let period_key = this.period_type === 'day' ? period_keys?.dayKey
                    : this.period_type === 'week' ? period_keys?.weekKey
                    : period_keys?.monthKey
                const reports = this.AggregatedReports

                console.log(timestamp,'timestamp........');
                console.log(period_keys,'period_keys........');
                console.log(period_type,'period_type........');
                console.log(till_key,'till_key........');
                console.log(reports,'reports........');

                if (reports?.period_key == period_key && reports?.period_type == period_type && reports?.till_key == till_key) { 
                    return reports
                } 
                return null
            },

            SummaryStats(){
                let r = this.CurrentReport
                if(!r){return []}
                let money = (v,d)=> this.MBS.actions.money(this.toNumber(v),d)
                return [
                    {label:'Invoices', value: money(r.invoice_count,0)},
                    {label:'Items Sold', value: money(r.item_total_quantity,0)},
                    {label:'Total Sales', value: money(r.item_total_sold_price)},
                    {label:'Total VAT', value: money(r.invoice_total_vat)},
                    {label:'Total Discount', value: money(r.item_total_discount)},
                ]
            },

            ReportItemsList(){
                let report = this.CurrentReport
                let joined_items = this.ItemsData
                let joined_item_map = {}
                joined_items.forEach(item => {
                    joined_item_map[item.key]=item
                });
                let items = report?report.items:null
                let has_special_code = false
                if(!items){return []}
                let list = Object.keys(items).map(item_key=>{
                    let item = items[item_key] || {}
                    let join = joined_item_map[item_key] || {}
                    let special_code = this.toNumber(join?.special_code)
                    let quantity = this.toNumber(item.quantity)
                    let price = this.toNumber(item.price)
                    let total_price = this.toNumber(item.total_price)
                    let total_sold_price = this.toNumber(item.total_sold_price)
                    let total_discount = this.toNumber(item.total_discount)
                    let totalVAT = this.toNumber(item.totalVAT)
                    if (item?.special_code) {
                        has_special_code = true
                    }
                    return {
                        item_key,
                        ...join,
                        ...item,
                        quantity, price, total_price, total_sold_price, total_discount, totalVAT,special_code,

                        price_:this.MBS.actions.money(price),
                        total_price_:this.MBS.actions.money(total_price),
                        total_sold_price_:this.MBS.actions.money(total_sold_price),
                        total_discount_:this.MBS.actions.money(total_discount),
                        vat:this.MBS.actions.money(totalVAT)||"0",
                    }
                })

                if (list?.find(item=>item.special_code>0)) {
                    list.sort(this.MBS.actions.dynamicSort("special_code",true))  
                }else{
                    list.sort(this.MBS.actions.dynamicSort("quantity",false))    
                }
                return list
            },

            HEADER_ITEMS(){
                return [
                    {id:1,name:"General",title:true},
                    {id:0,name:"",value:'icon_image',color:"primary",size:40,tile:true,show:true},
                    {id:0,name:"Barcode",value:'barcode',show:true},
                    {id:0,name:"S.Code",value:'special_code',show:true},
                    {id:0,name:"Item",value:"name",show:true},
                    {id:0,name:"Category",value:"category_name",show:true},
                    {id:0,name:"Department",value:'item_department_name',align:'right',show:true},
                    {id:0,name:"Quantity",value:'quantity',align:'right',show:true},
                    {id:0,name:"Price",value:'price_',align:'right',show:false},
                    {id:0,name:"Total Price",value:'total_price_',align:'right',show:false},
                    {id:0,name:"Total Sales",value:'total_sold_price_',align:'right',show:true},
                    {id:0,name:"Discount",value:'total_discount_',align:'right',show:false},
                    {id:0,name:"VAT",value:'vat',align:'right',show:true},
                    {id:0,name:"action",align:"right",show:true,item:[
                        {name:"View Item",action:"view_item",icon:"mdi-eye"},
                    ]},
                ]
            },

            TOTAL_ITEM_VALUES(){
                return [
                    {name:'Total Items',value:'quantity'},
                    {name:'Total Sales Price',value:'total_sold_price',show_value:'total_sold_price_',money:true},
                    {name:'Total Discount',value:'total_discount',show_value:'total_discount_',money:true},
                ]
            },
            ReportTypes(){
                const selected_till_key = this.selected_till_key
                const report = {
                    day:DATA.ITEMS.AGGREGATED_DAIRY_REPORTS,
                    week:DATA.ITEMS.AGGREGATED_WEEKLY_REPORTS,
                    month:DATA.ITEMS.AGGREGATED_MONTHLY_REPORTS,
                }
                
                const report_till = {
                    day:DATA.ITEMS.AGGREGATED_TILL_DAIRY_REPORTS,
                    week:DATA.ITEMS.AGGREGATED_TILL_WEEKLY_REPORTS,
                    month:DATA.ITEMS.AGGREGATED_TILL_MONTHLY_REPORTS,
                }

                return selected_till_key?report_till:report

            }
        },
        methods: {
            TABLE_ACTION(action,item){
                try {
                    if (action === "refresh") {
                        this.FETCH_REPORT()
                    }else if (action === "audit_aggregate_sales") {
                        // this.MBS.events.$emit("ON_DAYSHIFT_SELECTOR")
                         this.MBS.events.$emit("SALES_AUDIT_SYNC")  
                    }
                    // "export_excel" is handled internally by mbs-item-manager, matching
                    // the pattern already used in your other table pages.
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TABLE_ACTION',
                        page:PAGE_NAME,
                    })
                }
            },
            ITEM_ACTION(action,item){
                try {
                    if (action === "view_item") {
                        let item_key = item?item.item_key:null
                        if(!item_key){return}
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/items/"+item_key,true))
                    }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ITEM_ACTION',
                        page:PAGE_NAME,
                    })
                }
            },
            
            CONFIRM_AUDITING_AGGREGATE_SALE(dayshifts){
                try {
                    this.MBS.actions.dialogConfirmPassword({
                    // this.MBS.actions.dialog({
                        show:true,
                        fixed:true,
                        icon:"mdi-cloud-sync-outline",
                        title:"CONFIRM AUDITING SALES",
                        text:"Are you sure you want to audit aggregate sales? Enter your password to confirm this action.",
                        action:{
                            code:PAGE_NAME+'=AUDIT-AGGREGATE-SALES', 
                            data:{dayshifts},
                            all_users:true, 
                            phone_number_start:true,
                            get_access:{
                                page_name:"home",  
                            }
                        }
                    })
                     
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONFIRM_SYNCH_WITH_EIS',
                        page:PAGE_NAME, 
                    }) 
                }

            },
            async AUDITING_AGGREGATE_SALE(payload){
                try {   
                    let DayShifts = payload?.dayshifts
                    let SelectedCompany = this.SelectedCompany            
                    let company_key = SelectedCompany?SelectedCompany.company_key:null    
                    console.log(DayShifts,'DayShifts...............');
                    this.inputLoading = true 
                    let total_days = this.MBS.actions.SIZE(DayShifts)
                    let progress_number = 0
                    for (const dayshift of DayShifts) {
                        this.MBS.actions.progressDialog({
                            show:true,
                            fixed:false,
                            title:`processing ---${progress_number}/${total_days}-----`
                        }) 
                        if (!dayshift.eis_reconciled) {
                            let data = {
                                company_key:company_key, 
                                production:DATA.EIS.production,
                                day_shift_key : dayshift.key
    
                            }
                            let res = await this.MBS.actions.POST_REQUEST({
                                action:this.VALUE_ITEM,
                                path:"aggregateDayShiftSales",
                                data:data,
                                us:this.us
                            })
                            
                            console.log(res,progress_number+". res....."+dayshift.key);
                        }
                        progress_number++
                    }
                    this.inputLoading = false
                    this.MBS.actions.progressDialog()  
                    // console.log(res,'res-----------------------******');  
                    let mbs_text = this.MBS.text.item_action_success("Transactions","Synching")
                    this.MBS.actions.dialog({
                        show:true,
                        fixed:true,
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo, 
                    })
                     
                } catch (error) {
                    this.inputLoading = false
                    this.MBS.actions.progressDialog()  
                    this.MBS.actions.error({
                        error:error,
                        from:'AUDITING_AGGREGATE_SALE',
                        page:PAGE_NAME, 
                    }) 
                }

            },

            CONFIRM_SYNCH_WITH_EIS(dayshifts){
                try {
                    // this.MBS.actions.dialogConfirmPassword({
                    this.MBS.actions.dialog({
                        show:true,
                        fixed:true,
                        icon:"mdi-cloud-sync-outline",
                        title:"CONFIRM SYNCHING WITH EIS",
                        text:"Are you sure you want to synch EIS transactions? Enter your password to confirm this action.",
                        action:{
                            code:PAGE_NAME+'=SYNCH-WITH-EIS', 
                            data:{dayshifts},
                            all_users:true, 
                            phone_number_start:true,
                            get_access:{
                                page_name:"home",  
                            }
                        }
                    })
                     
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONFIRM_SYNCH_WITH_EIS',
                        page:PAGE_NAME, 
                    }) 
                }

            },
            async SYNCH_WITH_EIS(payload){
                try {           
                    let DayShifts = payload?.dayshifts  
                    let SelectedCompany = this.SelectedCompany            
                    let company_key = SelectedCompany?SelectedCompany.company_key:null    
                    console.log(DayShifts,'DayShifts...............');
                    this.inputLoading = true 
                    let total_days = this.MBS.actions.SIZE(DayShifts)
                    let progress_number = 0
                    let all_res = {}
                    for (const dayshift of DayShifts) {
                        this.MBS.actions.progressDialog({
                            show:true,
                            fixed:false,
                            title:`synching ---${progress_number}/${total_days}-----`
                        }) 
                        if (!dayshift.eis_reconciled) {
                            let data = {
                                company_key:company_key, 
                                production:DATA.EIS.production,
                                day_shift_key : dayshift.key
    
                            }
                            let res = await this.MBS.actions.POST_REQUEST({
                                action:this.VALUE_ITEM,
                                path:"eis-reconcile-day-shift-sales",
                                app:"app2",
                                data:data,
                                us:this.us
                            })
                            all_res[dayshift.key]=res 
                            console.log(res,progress_number+". res....."+dayshift.key);
                        }else{
                            all_res[dayshift.key]="Already Synched"
                        }
                        
                        progress_number++
                    }

                    console.log(all_res,"all_res.....");
                    
                    this.inputLoading = false
                    this.MBS.actions.progressDialog()  
                    let mbs_text = this.MBS.text.item_action_success("Transactions","Synching")
                    this.MBS.actions.dialog({
                        show:true,
                        fixed:true,
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo, 
                    })
                     
                } catch (error) {
                    this.inputLoading = false
                    this.MBS.actions.progressDialog()  
                    this.MBS.actions.error({
                        error:error,
                        from:'SYNCH_WITH_EIS',
                        page:PAGE_NAME, 
                    }) 
                }

            },


            // Exact client-side port of the Cloud Function's GET_PERIOD_KEYS — must stay
            // identical to that implementation, since the produced keys have to match the
            // ones AGGREGATE_SALE_ORDER writes report nodes under. If that backend function
            // ever changes, mirror the change here too.
            GET_PERIOD_KEYS(dayShiftKey){
                const moment = this.moment
                // IMPORTANT: use .utc() explicitly. The Cloud Function runs in UTC, so its
                // moment("2026-06-27") means midnight UTC. Using local moment() here in a
                // browser on UTC+2 (CAT/Malawi) produced midnight LOCAL instead — 2 hours
                // earlier in UTC terms — which resolved to a different dayKey/weekKey/
                // monthKey than the one the server actually wrote reports under.
                const dayMoment = moment.utc(this.toNumber(dayShiftKey))
                const dayKey = dayMoment.format('YYYY-MM-DD')
                const weekKey = dayMoment.clone().startOf('isoWeek').format('YYYY-MM-DD')
                const monthKey = dayMoment.format('YYYY-MM')
                return {
                    day: dayKey,
                    week: weekKey,
                    month: monthKey,
                    dayKey: String(moment.utc(dayKey).valueOf()),
                    weekKey: String(moment.utc(weekKey).valueOf()),
                    monthKey: String(moment.utc(monthKey).valueOf())
                }
            },

            ON_DATE_PICKED(){
                this.date_menu = false
                this.FETCH_REPORT()
            },

            // Fetches the report node for the currently selected period_type/date/till
            // directly from Realtime Database via fi_get_aggregated_report_items —
            // no cloud function needed, same pattern as the rest of this app's data fetching.
            async FETCH_REPORT(){
                try { 
                    if(!this.selected_date){return}
                    let company = this.SelectedCompany
                    let company_key = company?company.company_key:null
                    if(!company_key){return}

                    this.loading_report = true
                    this.report_data = null

                    // Local port of the Cloud Function's GET_PERIOD_KEYS — see the method
                    // above. Keeping it local (not MBS.actions) since it's not actually
                    // shared infrastructure, just a logic mirror that must stay in sync.
                    let timestamp = this.moment.utc(this.selected_date).valueOf()
                    let period_keys = this.GET_PERIOD_KEYS(timestamp)
                    let period_key = this.period_type === 'day' ? period_keys?.dayKey
                        : this.period_type === 'week' ? period_keys?.weekKey
                        : period_keys?.monthKey

                    if(!period_key){
                        this.loading_report = false
                        return
                    }

                    this.FI_CLOSE()
                    let res = await this.$store.dispatch('fi_get_aggregated_report_items',{
                        company_key:company_key,
                        period_type:this.period_type, // 'day' | 'week' | 'month'
                        period_key:period_key,
                        till_key:this.selected_till_key||null,
                        on:true
                    })

                    this.report_data = res?.data || null
                } catch (error) {
                    this.report_data = null
                    this.MBS.actions.error({
                        error:error,
                        from:'FETCH_REPORT',
                        page:PAGE_NAME,
                    })
                } finally {
                    this.loading_report = false
                }
            }, 
            

            FI_CLOSE(){ 
                try { 
                    this.$store.dispatch("off_refs",{
                        name:DATA.ITEMS.AGGREGATED_REPORTS.values
                    })
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FI_CLOSE',
                        page:PAGE_NAME, 
                    }) 
                }
            },

            DIALOG_YES(action){ 
                try {
                    if (action.code) { 
                        if (action.code ===PAGE_NAME+'=AUDIT-AGGREGATE-SALES') {
                            if (action.YES) {
                                this.AUDITING_AGGREGATE_SALE(action.data)
                            } else {
                                
                            }
                        }  
                        if (action.code ===PAGE_NAME+'=SYNCH-WITH-EIS') {
                            if (action.YES) {
                                this.SYNCH_WITH_EIS(action.data)
                            } else {
                                
                            }
                        }    
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DIALOG_YES',
                        page:PAGE_NAME, 
                    }) 
                }  
            }, 
        },
        beforeDestroy(){
            this.MBS.events.$off('DIALOG_YES', this.DIALOG_YES);     
            this.FI_CLOSE()
        },
        watch: {
            period_type(){
                try {
                    // Reset to a sensible default for the newly selected period type
                    // (the date picker's "type" prop switches between date/month, so the
                    // previously selected value's format may no longer be valid).
                    if (this.period_type === 'month') {
                        this.selected_date = this.moment().format('YYYY-MM')
                    } else {
                        this.selected_date = this.moment().format('YYYY-MM-DD')
                    }
                    this.FETCH_REPORT()
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'watch.period_type',
                        page:PAGE_NAME,
                    })
                }
            },
            selected_till_key(){
                this.FETCH_REPORT()
            },
        },
    }
</script>